/* Gulppp product options config - generated 23.10.26 from the PC - Product Options app.
   One entry per product handle. t = type (text, multiline, file, select, checkbox_group), l = label,
   n = name saved on the order, r = required, d = help text, sp = "Please choose one" first,
   o = choices [value, extra price in pence], lp = extra price in pence when a file is uploaded.
   Every priced choice must have a matching variant on the hidden product "Add-on" (gulppp-add-on)
   named "<n>: <value>" (or "<n>: Artwork uploaded" for files) at the same price.
   23.10.26: Home Bar 2 "Beer Badges: No Thank You" made free (was +£14.99). */
window.GP_OPTIONS = {
 "personalised-snack-board": [
  {
   "t": "text",
   "l": "Name of bar/ Top line text",
   "n": "Name of bar/ Top line text",
   "r": 1,
   "d": "If you require a specific font, please email the request to info@gulppp.com along with your order number otherwise we will use the default font as seen in 'The Dog & Bengal' example on the listing."
  },
  {
   "t": "text",
   "l": "Bottom line text",
   "n": "Bottom line text",
   "d": "If this is left blank we will use 'Bar Snacks' here as default."
  },
  {
   "t": "file",
   "l": "Image",
   "n": "Image",
   "r": 1,
   "d": "We will apply our 'pub sign effect' to real photographs."
  }
 ],
 "framed-printed-mirror-customised-mirror-personalised-mirror": [
  {
   "t": "file",
   "l": "Image",
   "n": "Image",
   "r": 1,
   "d": "Please upload the image you would like printing on the mirror"
  },
  {
   "t": "text",
   "l": "Text above image (optional)",
   "n": "Text above image (optional)"
  },
  {
   "t": "text",
   "l": "Text below image (optional)",
   "n": "Text below image (optional)"
  }
 ],
 "custom-football-print": [
  {
   "t": "file",
   "l": "Image",
   "n": "Image",
   "r": 1,
   "d": "Please add the photo you would like us to work with. Please be aware that the image quality will affect the quality of the final product. Please ensure the entire head and body of the subject is within the image and no body parts a cut off by the edge of the image."
  },
  {
   "t": "multiline",
   "l": "Text Above Image (Optional)",
   "n": "Text Above Image (Optional)",
   "d": "If you don't want any text please leave blank."
  },
  {
   "t": "multiline",
   "l": "Text Below Image (Optional)",
   "n": "Text Below Image (Optional)",
   "d": "If you don't want any text please leave blank."
  }
 ],
 "5l-mini-keg-growler-with-compensator-tap-heavy-duty-regulator": [
  {
   "t": "select",
   "l": "Options",
   "n": "Options",
   "o": [
    [
     "5L Mini Keg Growler With Compensator Tap & Heavy Duty Regulator without any CO2 canisters"
    ],
    [
     "50% OFF 20 x 16g threaded CO2 canisters",
     1500
    ],
    [
     "50% OFF 50 x 16g threaded CO2 canisters",
     3500
    ],
    [
     "50% OFF 100 x 16g threaded CO2 canisters",
     6500
    ]
   ]
  }
 ],
 "complete-twin-product-home-bar-set-up": [
  {
   "t": "select",
   "l": "Keg Coupler With Fittings 1",
   "n": "Keg Coupler With Fittings 1",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "S Type"
    ],
    [
     "D Type"
    ],
    [
     "A Type"
    ],
    [
     "G Type"
    ],
    [
     "Keykeg"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Keg Coupler With Fittings 2",
   "n": "Keg Coupler With Fittings 2",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "S Type"
    ],
    [
     "D Type"
    ],
    [
     "A Type"
    ],
    [
     "G Type"
    ],
    [
     "Keykeg"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Through Or Clamped To Bar",
   "n": "Through Or Clamped To Bar",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Supply Attached To A Clamp"
    ],
    [
     "Through The Bar"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Product Type",
   "n": "Product Type",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Lager/ Cider"
    ],
    [
     "Guinness/ Stout"
    ],
    [
     "Both Of The Above Options (Additional Primary Regulator)",
     4929
    ]
   ]
  },
  {
   "t": "select",
   "l": "Taps",
   "n": "Taps",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "1 x Lager/ Cider Tap and 1 x Guinness/ Stout Tap"
    ],
    [
     "2 x Lager/ Cider Taps"
    ],
    [
     "2 x Guinness/ Stout Taps"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Line Cleaning Equipment",
   "n": "Line Cleaning Equipment",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "5L Cleaning Bottle With Cap, Dip Tube & 5L Beer Line Cleaner",
     4906
    ],
    [
     "I Have My Own Cleaning Equipment"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Bar Lighting Transformer",
   "n": "Bar Lighting Transformer",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "I Want To Connect My Illuminated/ LED Badge Holders To A Power Source",
     3899
    ],
    [
     "I Do Not Have Illuminated/ LED Badge Holders/ I Already Have a Transformer"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Gas",
   "n": "Gas",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "We Will Help Source A Supplier Local To You"
    ]
   ]
  }
 ],
 "complete-single-product-home-bar-set-up": [
  {
   "t": "select",
   "l": "Keg Coupler With Fittings 1",
   "n": "Keg Coupler With Fittings 1",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "S Type"
    ],
    [
     "D Type"
    ],
    [
     "A Type"
    ],
    [
     "G Type"
    ],
    [
     "Keykeg"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Through Or Clamped To Bar",
   "n": "Through Or Clamped To Bar",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Supply Attached To A Clamp"
    ],
    [
     "Through The Bar"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Taps",
   "n": "Taps",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "1 x Lager/ Cider Tap"
    ],
    [
     "1 x Guinness/ Stout Tap"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Line Cleaning Equipment",
   "n": "Line Cleaning Equipment",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "5L Cleaning Bottle With Cap, Dip Tube & 5L Beer Line Cleaner",
     4906
    ],
    [
     "I Have My Own Cleaning Equipment"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Bar Lighting Transformer",
   "n": "Bar Lighting Transformer",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "I Want To Connect My Illuminated/ LED Badge Holders To A Power Source",
     3899
    ],
    [
     "I Do Not Have Illuminated/ LED Badge Holders/ I Already Have a Transformer"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Gas",
   "n": "Gas",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "We Will Help Source A Supplier Local To You"
    ]
   ]
  }
 ],
 "beer-mats": [
  {
   "t": "file",
   "l": "Please add a square image",
   "n": "Please add a square image",
   "r": 1
  },
  {
   "t": "select",
   "l": "Pub Sign Effect",
   "n": "Pub Sign Effect",
   "r": 1,
   "d": "This gives a more authentic look. We would recommend it for real, full colour photographs.",
   "sp": 1,
   "o": [
    [
     "Yes please"
    ],
    [
     "No thanks"
    ]
   ]
  },
  {
   "t": "text",
   "l": "Text above the image",
   "n": "Text above the image",
   "r": 1
  },
  {
   "t": "text",
   "l": "Text below the image",
   "n": "Text below the image",
   "r": 1
  },
  {
   "t": "select",
   "l": "Matching bar runner",
   "n": "Matching bar runner",
   "r": 1,
   "d": "55mm x 22mm, rubber based & machine washable",
   "sp": 1,
   "o": [
    [
     "1 x Bar Runner",
     2499
    ],
    [
     "2 x Bar Runners",
     3999
    ],
    [
     "No thanks"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Matching hanging pub sign",
   "n": "Matching hanging pub sign",
   "r": 1,
   "d": "280mm x 340mm, aluminium faced with chains and hanger",
   "sp": 1,
   "o": [
    [
     "Yes please",
     4999
    ],
    [
     "No thanks"
    ]
   ]
  }
 ],
 "matching-bar-runners-and-beer-mats": [
  {
   "t": "file",
   "l": "Please add a square image",
   "n": "Please add a square image",
   "r": 1
  },
  {
   "t": "select",
   "l": "Pub Sign Effect",
   "n": "Pub Sign Effect",
   "r": 1,
   "d": "This gives a more authentic look. We would recommend it for real, full colour photographs.",
   "sp": 1,
   "o": [
    [
     "Yes please"
    ],
    [
     "No thanks"
    ]
   ]
  },
  {
   "t": "text",
   "l": "Text in the arch",
   "n": "Text in the arch",
   "r": 1
  },
  {
   "t": "text",
   "l": "Text underneath the arch",
   "n": "Text underneath the arch",
   "r": 1
  },
  {
   "t": "select",
   "l": "Matching beer mats",
   "n": "Matching beer mats",
   "r": 1,
   "d": "94mm x 94mm Beer Mats",
   "sp": 1,
   "o": [
    [
     "100 Beer Mats",
     4999
    ],
    [
     "250 Beer Mats",
     6999
    ],
    [
     "No thanks"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Matching hanging pub sign",
   "n": "Matching hanging pub sign",
   "r": 1,
   "d": "280mm x 340mm, aluminium faced with chains and hanger",
   "sp": 1,
   "o": [
    [
     "Yes please",
     4999
    ],
    [
     "No thanks"
    ]
   ]
  }
 ],
 "home-bar-1-product-system": [
  {
   "t": "select",
   "l": "Keg Coupler With Fittings 1",
   "n": "Keg Coupler With Fittings 1",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "S Type",
     3808
    ],
    [
     "U Type",
     3808
    ],
    [
     "D Type",
     3808
    ],
    [
     "A Type",
     3808
    ],
    [
     "G Type",
     3808
    ],
    [
     "Keykeg",
     5892
    ]
   ]
  },
  {
   "t": "select",
   "l": "Product Type",
   "n": "Product Type",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Lager/ Cider"
    ],
    [
     "Guinness/ Stout"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Gas",
   "n": "Gas",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "We will help source a gas supplier local to you"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Tower/ Font",
   "n": "Tower/ Font",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Ikon 1 Out LED Badge Holders, Drip Tray, Taps & Pipework",
     18923
    ],
    [
     "Chaplin 1 Out LED Badge Holders, Drip Tray and Bracket",
     25000
    ],
    [
     "Classic Cobra 1 Out LED Badge Holders, Drip Tray and Bracket",
     29159
    ],
    [
     "None - I Have My Own Tower"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Through Or Clamped To Bar",
   "n": "Through Or Clamped To Bar",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Supply Attached To A Clamp"
    ],
    [
     "Through The Bar"
    ],
    [
     "N/A"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Tap (if ordering a tower)",
   "n": "Tap (if ordering a tower)",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "1 x Lager/ Cider Tap"
    ],
    [
     "1 x Guinness/ Stout Tap"
    ],
    [
     "None - I Have My Own Tap"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Line Cleaning Equipment",
   "n": "Line Cleaning Equipment",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "5L Cleaning Bottle With S Type Cap, Dip Tube & 5L Beer Line Cleaner",
     4906
    ],
    [
     "5L Cleaning Bottle With A Type Cap, Dip Tube & 5L Beer Line Cleaner",
     4906
    ],
    [
     "5L Cleaning Bottle With G Type Cap, Dip Tube & 5L Beer Line Cleaner",
     4906
    ],
    [
     "5L Cleaning Bottle With D Type Cap, Dip Tube & 5L Beer Line Cleaner",
     4906
    ],
    [
     "5L Cleaning Bottle With S Type Coupler, S Type Cap (Combined Are Cheaper Than A Keykeg Cap), Dip Tube & 5L Beer Line Cleaner",
     7187
    ],
    [
     "I Have My Own Cleaning Equipment"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Bar Lighting Transformer",
   "n": "Bar Lighting Transformer",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "I Need To Connect My Illuminated/ LED Badge Holders To A Power Source",
     3899
    ],
    [
     "I Do Not Have Illuminated/ LED Badge Holders/ I Already Have a Transformer"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Beer Badge",
   "n": "Beer Badge",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Personalised",
     1499
    ],
    [
     "Guinness",
     1499
    ],
    [
     "Carling",
     1499
    ],
    [
     "Stella Artois",
     1499
    ],
    [
     "Peroni",
     1499
    ],
    [
     "Foster's",
     1499
    ],
    [
     "Other (please attach artwork)",
     1499
    ],
    [
     "No Thank You"
    ]
   ]
  },
  {
   "t": "file",
   "l": "Beer Badge Artwork",
   "n": "Beer Badge Artwork",
   "d": "Only applicable if you have selected the 'personalised' or 'other' beer badge options.",
   "lp": 1499
  }
 ],
 "home-bar-4-product-system": [
  {
   "t": "select",
   "l": "Keg Coupler With Fittings 1",
   "n": "Keg Coupler With Fittings 1",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "S Type",
     3634
    ],
    [
     "U Type",
     2928
    ],
    [
     "D Type",
     3928
    ],
    [
     "A Type",
     4015
    ],
    [
     "G Type",
     4015
    ],
    [
     "Keykeg",
     5892
    ]
   ]
  },
  {
   "t": "select",
   "l": "Keg Coupler With Fittings 2",
   "n": "Keg Coupler With Fittings 2",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "S Type",
     3634
    ],
    [
     "U Type",
     3928
    ],
    [
     "D Type",
     3928
    ],
    [
     "A Type",
     4015
    ],
    [
     "G Type",
     4015
    ],
    [
     "Keykeg",
     5892
    ]
   ]
  },
  {
   "t": "select",
   "l": "Keg Coupler With Fittings 3",
   "n": "Keg Coupler With Fittings 3",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "S Type",
     3634
    ],
    [
     "U Type",
     3928
    ],
    [
     "D Type",
     3928
    ],
    [
     "A Type",
     4015
    ],
    [
     "G Type",
     4015
    ],
    [
     "Keykeg",
     5892
    ]
   ]
  },
  {
   "t": "select",
   "l": "Keg Coupler With Fittings 4",
   "n": "Keg Coupler With Fittings 4",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "S Type",
     3634
    ],
    [
     "U Type",
     3928
    ],
    [
     "D Type",
     3928
    ],
    [
     "A Type",
     4015
    ],
    [
     "G Type",
     4015
    ],
    [
     "Keykeg",
     5892
    ]
   ]
  },
  {
   "t": "select",
   "l": "Product Type",
   "n": "Product Type",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Lager/ Cider"
    ],
    [
     "Guinness/ Stout"
    ],
    [
     "Both Of the Above Options (Swap 1 x Secondary Reg For Another Primary Reg)",
     2303
    ]
   ]
  },
  {
   "t": "select",
   "l": "Gas",
   "n": "Gas",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "10L Cylinder Of 60% Carbon Dioxide 40% Nitrogen (For Lager and Cider)",
     14010
    ],
    [
     "10L Cylinder Of 30% Carbon Dioxide 70% Nitrogen (For Guinness and Stouts)",
     14010
    ],
    [
     "Both Of The Above",
     28020
    ],
    [
     "None - I Will Source My Own Gas"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Tower/ Font",
   "n": "Tower/ Font",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Classic Cobra 4 Out LED Badge Holders, Drip Tray and Bracket",
     31350
    ],
    [
     "T Bar 4 Out LED Badge Holders, Drip Tray and Bracket",
     26132
    ],
    [
     "None - I Have My Own Tower"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Through Or Clamped To Bar",
   "n": "Through Or Clamped To Bar",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Supply Attached To A Clamp"
    ],
    [
     "Through The Bar"
    ],
    [
     "N/A"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Taps",
   "n": "Taps",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "2 x Lager/ Cider Taps and 2 x Guinness/ Stout Taps",
     17824
    ],
    [
     "3 x Lager/ Cider Taps and 1 x Guinness/ Stout Tap",
     17824
    ],
    [
     "1 x Lager/ Cider Tap and 3 x Guinness/ Stout Taps",
     17824
    ],
    [
     "4 x Lager/ Cider Taps",
     17824
    ],
    [
     "4 x Guinness/ Stout Taps",
     17824
    ],
    [
     "None - I Have My Own Taps"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Bar Lighting Transformer",
   "n": "Bar Lighting Transformer",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "I Need To Connect My Illuminated/ LED Badge Holders To A Power Source",
     3899
    ],
    [
     "I Do Not Have Illuminated/ LED Badge Holders/ I Already Have a Transformer"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Line Cleaning Equipment",
   "n": "Line Cleaning Equipment",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "5L Cleaning Bottle With S Type Cap, Dip Tube & 5L Beer Line Cleaner",
     4906
    ],
    [
     "5L Cleaning Bottle With A Type Cap, Dip Tube & 5L Beer Line Cleaner",
     4906
    ],
    [
     "5L Cleaning Bottle With G Type Cap, Dip Tube & 5L Beer Line Cleaner",
     4906
    ],
    [
     "5L Cleaning Bottle With D Type Cap, Dip Tube & 5L Beer Line Cleaner",
     4906
    ],
    [
     "5L Cleaning Bottle With S Type Coupler, S Type Cap (Combined Are Cheaper Than A Keykeg Cap), Dip Tube & 5L Beer Line Cleaner",
     7187
    ],
    [
     "I Have My Own Cleaning Equipment"
    ]
   ]
  }
 ],
 "home-bar-2-product-system": [
  {
   "t": "select",
   "l": "Keg Coupler With Fittings 1",
   "n": "Keg Coupler With Fittings 1",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "S Type",
     3805
    ],
    [
     "U Type",
     3805
    ],
    [
     "D Type",
     3805
    ],
    [
     "A Type",
     3805
    ],
    [
     "G Type",
     3805
    ],
    [
     "Keykeg",
     4852
    ]
   ]
  },
  {
   "t": "select",
   "l": "Keg Coupler With Fittings 2",
   "n": "Keg Coupler With Fittings 2",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "S Type",
     3805
    ],
    [
     "U Type",
     3805
    ],
    [
     "D Type",
     3805
    ],
    [
     "A Type",
     3805
    ],
    [
     "G Type",
     3805
    ],
    [
     "Keykeg",
     4852
    ]
   ]
  },
  {
   "t": "select",
   "l": "Product Type",
   "n": "Product Type",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Lager/ Cider"
    ],
    [
     "Guinness/ Stout"
    ],
    [
     "Both Of the Above Options (Swap Secondary Reg For Another Primary Reg)",
     2421
    ]
   ]
  },
  {
   "t": "select",
   "l": "Gas",
   "n": "Gas",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "We will help source a gas supplier local to you"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Tower/ Font",
   "n": "Tower/ Font",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Ikon 2 Out LED Badge Holders, Drip Tray & Taps",
     26257
    ],
    [
     "T Bar 2 Out LED Badge Holders, Drip Tra2y and Bracket",
     32399
    ],
    [
     "Classic Cobra 2 Out LED Badge Holders, Drip Tray & Taps",
     36799
    ],
    [
     "None - I Have My Own Tower"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Through Or Clamped To Bar",
   "n": "Through Or Clamped To Bar",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Supply Attached To A Clamp"
    ],
    [
     "Through The Bar"
    ],
    [
     "N/A"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Taps (if ordering a tower)",
   "n": "Taps (if ordering a tower)",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "1 x Lager/ Cider Tap and 1 x Guinness/ Stout Tap"
    ],
    [
     "2 x Lager/ Cider Taps"
    ],
    [
     "2 x Guinness/ Stout Taps"
    ],
    [
     "None - I Have My Own Taps"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Line Cleaning Equipment",
   "n": "Line Cleaning Equipment",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "5L Cleaning Bottle With S Type Cap, Dip Tube & 5L Beer Line Cleaner",
     5198
    ],
    [
     "5L Cleaning Bottle With A Type Cap, Dip Tube & 5L Beer Line Cleaner",
     5198
    ],
    [
     "5L Cleaning Bottle With G Type Cap, Dip Tube & 5L Beer Line Cleaner",
     5198
    ],
    [
     "5L Cleaning Bottle With D Type Cap, Dip Tube & 5L Beer Line Cleaner",
     5198
    ],
    [
     "5L Cleaning Bottle With S Type Coupler, S Type Cap (Combined Are Cheaper Than A Keykeg Cap), Dip Tube & 5L Beer Line Cleaner",
     7977
    ],
    [
     "I Have My Own Cleaning Equipment"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Bar Lighting Transformer",
   "n": "Bar Lighting Transformer",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "I Need To Connect My Illuminated/ LED Badge Holders To A Power Source",
     3899
    ],
    [
     "I Do Not Have Illuminated/ LED Badge Holders/ I Already Have a Transformer"
    ]
   ]
  },
  {
   "t": "checkbox_group",
   "l": "Beer Badges",
   "n": "Beer Badges",
   "o": [
    [
     "Personalised",
     1499
    ],
    [
     "Personalised",
     1499
    ],
    [
     "Guinness",
     1499
    ],
    [
     "Carling",
     1499
    ],
    [
     "Stella Artois",
     1499
    ],
    [
     "Peroni",
     1499
    ],
    [
     "Foster's",
     1499
    ],
    [
     "Other",
     1499
    ],
    [
     "Other",
     1499
    ],
    [
     "No Thank You"
    ]
   ]
  },
  {
   "t": "file",
   "l": "Beer Badge Artwork 1",
   "n": "Beer Badge Artwork 1",
   "d": "Only applicable if you have selected the 'personalised' or 'other' beer badge options.",
   "lp": 1499
  },
  {
   "t": "file",
   "l": "Beer Badge Artwork 2",
   "n": "Beer Badge Artwork 2",
   "d": "Only applicable if you have selected the 'personalised' or 'other' beer badge options more than once.",
   "lp": 1499
  }
 ],
 "home-bar-3-product-system": [
  {
   "t": "select",
   "l": "Keg Coupler With Fittings 1",
   "n": "Keg Coupler With Fittings 1",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "S Type",
     3634
    ],
    [
     "U Type",
     3928
    ],
    [
     "D Type",
     3928
    ],
    [
     "A Type",
     4015
    ],
    [
     "G Type",
     4015
    ],
    [
     "Keykeg",
     5892
    ]
   ]
  },
  {
   "t": "select",
   "l": "Keg Coupler With Fittings 2",
   "n": "Keg Coupler With Fittings 2",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "S Type",
     3634
    ],
    [
     "U Type",
     3928
    ],
    [
     "D Type",
     3928
    ],
    [
     "A Type",
     4015
    ],
    [
     "G Type",
     4015
    ],
    [
     "Keykeg",
     5892
    ]
   ]
  },
  {
   "t": "select",
   "l": "Keg Coupler With Fittings 3",
   "n": "Keg Coupler With Fittings 3",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "S Type",
     3634
    ],
    [
     "U Type",
     3928
    ],
    [
     "D Type",
     3928
    ],
    [
     "A Type",
     4015
    ],
    [
     "G Type",
     4015
    ],
    [
     "Keykeg",
     5892
    ]
   ]
  },
  {
   "t": "select",
   "l": "Product Type",
   "n": "Product Type",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Lager/ Cider"
    ],
    [
     "Guinness/ Stout"
    ],
    [
     "Both Of the Above Options (Swap 1 x Secondary Reg For Another Primary Reg)",
     2303
    ]
   ]
  },
  {
   "t": "select",
   "l": "Gas",
   "n": "Gas",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "10L Cylinder Of 60% Carbon Dioxide 40% Nitrogen (For Lager and Cider)",
     14010
    ],
    [
     "10L Cylinder Of 30% Carbon Dioxide 70% Nitrogen (For Guinness and Stouts)",
     14010
    ],
    [
     "Both Of The Above",
     28020
    ],
    [
     "None - I Will Source My Own Gas"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Tower/ Font",
   "n": "Tower/ Font",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Classic Cobra 3 Out LED Badge Holders, Drip Tray and Bracket",
     31040
    ],
    [
     "T Bar 3 Out LED Badge Holders, Drip Tray and Bracket",
     26132
    ],
    [
     "None - I Have My Own Tower"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Taps",
   "n": "Taps",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "2 x Lager/ Cider Tap and 1 x Guinness/ Stout Tap",
     13368
    ],
    [
     "1 x Lager/ Cider Tap and 2 x Guinness/ Stout Tap",
     13368
    ],
    [
     "3 x Lager/ Cider Taps",
     13368
    ],
    [
     "3 x Guinness/ Stout Taps",
     13368
    ],
    [
     "None - I Have My Own Taps"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Through Or Clamped To Bar",
   "n": "Through Or Clamped To Bar",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "Supply Attached To A Clamp"
    ],
    [
     "Through The Bar"
    ],
    [
     "N/A"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Bar Lighting Transformer",
   "n": "Bar Lighting Transformer",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "I Need To Connect My Illuminated/ LED Badge Holders To A Power Source",
     3899
    ],
    [
     "I Do Not Have Illuminated/ LED Badge Holders/ I Already Have a Transformer"
    ]
   ]
  },
  {
   "t": "select",
   "l": "Line Cleaning Equipment",
   "n": "Line Cleaning Equipment",
   "r": 1,
   "sp": 1,
   "o": [
    [
     "5L Cleaning Bottle With S Type Cap, Dip Tube & 5L Beer Line Cleaner",
     4906
    ],
    [
     "5L Cleaning Bottle With A Type Cap, Dip Tube & 5L Beer Line Cleaner",
     4906
    ],
    [
     "5L Cleaning Bottle With G Type Cap, Dip Tube & 5L Beer Line Cleaner",
     4906
    ],
    [
     "5L Cleaning Bottle With D Type Cap, Dip Tube & 5L Beer Line Cleaner",
     4906
    ],
    [
     "5L Cleaning Bottle With S Type Coupler, S Type Cap (Combined Are Cheaper Than A Keykeg Cap), Dip Tube & 5L Beer Line Cleaner",
     7187
    ],
    [
     "I Have My Own Cleaning Equipment"
    ]
   ]
  }
 ],
 "personalised-photo-insert-for-travel-mug": [
  {
   "t": "file",
   "l": "Photo 1",
   "n": "Photo 1",
   "r": 1
  },
  {
   "t": "file",
   "l": "Photo 2",
   "n": "Photo 2"
  }
 ],
 "blank-brans": [
  {
   "t": "file",
   "l": "Badge Artwork 1",
   "n": "Badge Artwork 1"
  },
  {
   "t": "file",
   "l": "Badge Artwork 2",
   "n": "Badge Artwork 2"
  },
  {
   "t": "file",
   "l": "Badge Artwork 3",
   "n": "Badge Artwork 3"
  },
  {
   "t": "file",
   "l": "Badge Artwork 4",
   "n": "Badge Artwork 4"
  },
  {
   "t": "file",
   "l": "Badge Artwork 5",
   "n": "Badge Artwork 5"
  },
  {
   "t": "multiline",
   "l": "Artwork Quantities",
   "n": "Artwork Quantities",
   "d": "Please advise what quantities of each artwork you would like. (If applicable)."
  }
 ],
 "personalised-pub-sign": [
  {
   "t": "text",
   "l": "Text Above The Image",
   "n": "Text Above The Image",
   "max": "100"
  },
  {
   "t": "text",
   "l": "Text Below The Image",
   "n": "Text Below The Image",
   "max": "100"
  },
  {
   "t": "file",
   "l": "Square Image",
   "n": "Square Image"
  },
  {
   "t": "select",
   "l": "Matching Beer Mats",
   "n": "Matching Beer Mats",
   "d": "94mm x 94mm Beer Mats",
   "o": [
    [
     "No Thank You"
    ],
    [
     "100 x Matching Beer Mats",
     4999
    ],
    [
     "250 x Matching Beer Mats",
     6999
    ]
   ]
  },
  {
   "t": "select",
   "l": "Matching Bar Runner",
   "n": "Matching Bar Runner",
   "d": "Non-slip rubber base topped with polyester surface. Machine Washable",
   "o": [
    [
     "No Thank You"
    ],
    [
     "1 x Matching Bar Runner (58cm x 22)",
     2499
    ],
    [
     "2 x Matching Bar Runners (58cm x 22)",
     4499
    ]
   ]
  },
  {
   "t": "select",
   "l": "Matching Bar Snack Board",
   "n": "Matching Bar Snack Board",
   "d": "5mm thick foamex 594mm x 420mm with 16 x clips for snack hanging. We will automatically add 'Bar Snacks' under pub name (arched above) unless stated otherwise.",
   "o": [
    [
     "No Thank You"
    ],
    [
     "Yes Please",
     3999
    ]
   ]
  }
 ],
 "novelty-travel-mug-personalised-photo": [
  {
   "t": "file",
   "l": "Photo 1",
   "n": "Photo 1",
   "r": 1
  },
  {
   "t": "file",
   "l": "Photo 2",
   "n": "Photo 2"
  }
 ]
};

/* Branded beer badges (product type 'Beer Badge'): optional sticky pad, added 24.10.26 */
window.GP_OPTIONS['type:Beer Badge'] = [{ t: 'select', l: 'Sticky Pad', n: 'Sticky Pad', d: 'Double-sided adhesive pad for fixing the lens into your badge holder.', o: [['No Thank You'], ['Add a sticky pad', 50]] }];
